import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Eyebrow } from './HomeSections';

const PATHS = [
  ['Technology & Data', 'Software development, data, cloud and more.', 'https://images.pexels.com/photos/34803969/pexels-photo-34803969.jpeg?auto=compress&cs=tinysrgb&w=800', 'technical'],
  ['Business & Operations', 'Operations, product management, consulting and more.', 'https://images.unsplash.com/photo-1497032628192-86f99bcd76bc?w=800&q=80', 'nontechnical'],
  ['Marketing & Creative', 'Digital marketing, content, design and more.', 'https://images.pexels.com/photos/4238498/pexels-photo-4238498.jpeg?auto=compress&cs=tinysrgb&w=800', 'nontechnical'],
  ['Finance & Analytics', 'Finance, analytics, business intelligence and more.', 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&q=80', 'technical'],
];

export const CareerPaths = () => (
  <section className="bg-[#0b1f4d] text-white" id="career-paths" style={{ scrollMarginTop: 80 }} data-testid="home-career-paths">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 pt-8 pb-20">
      <div className="flex flex-wrap items-end justify-between gap-4 mb-10">
        <div>
          <Eyebrow>Explore career paths</Eyebrow>
          <h2 className="font-outfit text-3xl sm:text-4xl font-bold">Choose your direction.</h2>
          <p className="text-slate-300 mt-3">Explore popular roles, see what it takes and find the right path for you.</p>
        </div>
        <Link to="/career-readiness-check" className="text-sm font-semibold text-teal-300 hover:text-teal-200 inline-flex items-center gap-1.5" data-testid="home-all-paths-link">Find your best-fit path <ArrowRight className="w-4 h-4" /></Link>
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {PATHS.map(([t, d, img, tab], i) => (
          <Link key={t} to={`/learning-paths?tab=${tab}`} data-testid={`home-path-${i}`}
            className="group rounded-2xl overflow-hidden bg-white/[0.04] border border-white/10 hover:border-teal-300 transition-colors">
            <div className="h-36 overflow-hidden"><img src={img} alt={t} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" /></div>
            <div className="p-5 flex items-end gap-3">
              <div className="flex-1"><p className="font-outfit font-semibold">{t}</p><p className="text-sm text-slate-400 mt-1.5">{d}</p></div>
              <span className="w-9 h-9 shrink-0 rounded-full border border-white/20 group-hover:bg-teal-400 group-hover:border-teal-400 group-hover:text-[#0b1f4d] flex items-center justify-center transition-colors"><ArrowRight className="w-4 h-4" /></span>
            </div>
          </Link>
        ))}
      </div>
    </div>
  </section>
);

const STEPS = [
  ['Join for free', 'Create your profile and join the Talent Network.', '/network'],
  ['Discover your readiness', 'Take the Career Readiness Check and identify your strengths and gaps.', '/career-readiness-check'],
  ['Talk with a career guide', 'Book a 1:1 consultation to discuss your goals.', '/apply?plan=clarity-session'],
  ['Get your plan', 'Receive a personalized action plan with next steps.', '/my-journey'],
  ['Build and grow', 'Choose learning paths and access opportunities.', '/my-journey'],
];

export const JourneySteps = () => (
  <section className="bg-white" id="how-it-works" style={{ scrollMarginTop: 80 }} data-testid="home-steps">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-20">
      <div className="flex flex-wrap items-end justify-between gap-4 mb-12">
        <div><Eyebrow light>A clear path forward</Eyebrow><h2 className="font-outfit text-3xl sm:text-4xl font-bold text-[#0b1f4d]">Your journey, step by step.</h2></div>
        <Link to="/my-journey" className="text-sm font-semibold text-[#0b1f4d] inline-flex items-center gap-1.5" data-testid="home-steps-journey-link">Open My Career Journey <ArrowRight className="w-4 h-4" /></Link>
      </div>
      <ol className="grid sm:grid-cols-2 lg:grid-cols-5 gap-8 relative">
        <span className="hidden lg:block absolute top-5 left-5 right-5 h-px bg-slate-200" />
        {STEPS.map(([t, d, to], i) => (
          <li key={t} className="relative" data-testid={`home-step-${i + 1}`}>
            <Link to={to} className="group block">
              <span className={`relative z-10 w-10 h-10 rounded-full flex items-center justify-center text-sm font-bold ${i === 0 ? 'bg-[#0b1f4d] text-white' : 'bg-teal-50 text-teal-700 group-hover:bg-teal-400 group-hover:text-[#0b1f4d]'} transition-colors`}>{String(i + 1).padStart(2, '0')}</span>
              <p className="font-outfit font-semibold text-[#0b1f4d] mt-4">{t}</p>
              <p className="text-sm text-slate-500 mt-1.5 leading-relaxed">{d}</p>
            </Link>
          </li>
        ))}
      </ol>
    </div>
  </section>
);
